<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    
    <div class="root-body-inner">
        <div class="pml-header">
            <div class="pml-header-title">{{groupName}}</div>
        </div>

        <partner-mart-locations-inventory-grid [groupId]="groupId"></partner-mart-locations-inventory-grid>
    </div>
</div>
